<!-- static content data from lang: company_management -->
<template>
  <div>
     <div class="h-100" v-loading="loading">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <template v-for="(message) in alertMessages">
              <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <template v-for="(message) in successMessages">
              <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                          :label="lang.label.companyName"
                          name="company name"
                          autocomplete="off"
                          rules="required"
                          v-model="model.companyName"
                          labelClasses="form-control-label asterisk-mark"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group photo-upload">
                  <base-input
                    :label="lang.label.uploadLogo"
                  >
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      class="textFile"
                      v-model="model.logo"
                      autocomplete="off"
                      @vdropzone-file-added="filesAdded"
                      @vdropzone-success="fileSuccess"
                      @vdropzone-removed-file="filesRemoved"
                    ></vue-dropzone>
                  </base-input>
                </div>

                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit" :disabled="uploading">{{lang.label.buttons.save}}</base-button>
                  <base-button
                    type="danger"
                    @click="$router.push({path: 'list'})"
                  >{{lang.label.buttons.cancel}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
 import Alert from "@/components/BaseAlert.vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  components: {
    RouteBreadCrumb,
    vueDropzone: vue2Dropzone,
    Alert
  },
  data() {
    return {
      lang: this.$lang.company_management,
      loading:false,
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      uploading: false,
      model: {
        companyName: "",
        logo: "",
      },
      dropzoneOptions: {
            url: "https://httpbin.org/post",
            thumbnailWidth: 200,
            addRemoveLinks: true,
            uploadMultiple: false,
            maxFilesize: 10,
            maxFiles: 1,
            acceptedFiles: ".jpg, .jpeg, .png",
            dictDefaultMessage:
                "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
      }
    };
  },
  // mounted(){
  //   this.$store.commit('FLASH/SET_FLASH', { message: 'some message', variant: 'success' });
  // },
  methods: {
    fileSuccess: function (file) {
          this.uploading = false;
      },
    filesRemoved: function(file,error){
          this.uploading = false;
    },
    filesAdded(file){
          this.uploading = true;
    },
    onSubmit() {
      let self = this;
      this.loading = true;
        let formData = new FormData();
            formData.append('Name', this.model.companyName);
        if(this.$refs.myVueDropzone) {
            let imageFiles = this.$refs.myVueDropzone.dropzone.files;
            imageFiles.forEach((object, index) => {
                formData.append('Logo', object);
            });
        }
            this.$store.dispatch('createCompany', formData)
                    .then(response => {
                       if (response.status == 200) {
                      this.model.companyName = '';
                      this.flash({message: response.data.message, variant: 'success'});
                        this.$router.push({ name: "companyManagementList"});
                        this.loading = false;
                       }else {
                           if(typeof response.data.message != 'object'){
                               this.alertMessages.push(response.data.message);
                           }else{
                               let array = new Array();
                               for (let key of Object.keys(response.data.message)) {
                                   let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                   array.push(obj)
                               }
                               this.alertMessages.push(array.join(', '));
                               setTimeout(function () {
                                   self.alertMessages = [];
                               },5000)
                           }
                                this.loading = false;
                            }

                    })
                    .catch(error => {
                        this.loading = false;
                    })
      //

    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
